import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { opsActions } from "../../actions";

function AirtableReconciliationReport(props) {

    const { ops, org, authentication, getAirtableReconciliationReport } = props;
    const org_id = org.current_org_id;
    const report = ops.airtable_reconciliation_report

    const [reportType, setReportType] = useState('');

    useEffect(
        () => {
            getAirtableReconciliationReport(org_id);
        },
        [org.current_org_id]
    );

    const appDupesList = report?.appDupes.map((fileName, i) => (
        <tr>
            <td>
                {fileName}
            </td>
        </tr>

    ));

    const airtableDupesList = report?.airtableDupes.map((fileName, i) => (
        <tr>
            <td>
                {fileName}
            </td>
        </tr>

    ));

    const missingFromAppList = report?.missingFromApp.map((fileName, i) => (
        <tr>
            <td>
                {fileName}
            </td>
        </tr>

    ));

    const missingFromAirtableList = report?.missingFromAirtable.map((fileName, i) => (
        <tr>
            <td>
                {fileName}
            </td>
        </tr>

    ));

    return (
        <div>
            <div class="searchMain">
                <div>
                    <div className="contextMenu" onClick={() => {setReportType('appDupes')}}>App Dupes</div>
                    <div className="contextMenu" onClick={() => {setReportType('airtableDupes')}}>Airtable Dupes</div>
                    <div className="contextMenu" onClick={() => {setReportType('missingFromApp')}}>Missing From App</div>
                    <div className="contextMenu" onClick={() => {setReportType('missingFromAirtable')}}>Missing From Airtable</div>
                </div>
                <br />
                {
                    (report) &&
                    <table class="paleBlueRows">
                        <tbody>
                            { (reportType === 'appDupes') && (
                                <>
                                {appDupesList}
                                </>
                            )}
                            { (reportType === 'airtableDupes') && (
                                <>
                                {airtableDupesList}
                                </>
                            )}
                            { (reportType === 'missingFromApp') && (
                                <>
                                {missingFromAppList}
                                </>
                            )}
                            { (reportType === 'missingFromAirtable') && (
                                <>
                                {missingFromAirtableList}
                                </>
                            )}                                                                                    
                            
                        </tbody>
                    </table>

                }
            </div>
        </div>
    );
};


function mapStateToProps(state) {
    const { ops, org } = state;
    return {
        ops,
        org
    };
}

const actionCreators = {
    getAirtableReconciliationReport: opsActions.getAirtableReconciliationReport,
};

const connectedAirtableReconciliationReport = connect(mapStateToProps, actionCreators)(AirtableReconciliationReport);
export { connectedAirtableReconciliationReport as AirtableReconciliationReport };
